/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Typed HTTP call functions generated from http-endpoints.yaml.
 * Each function returns Promise<XxxResult> — never throws.
 * Domain errors and transport errors are discriminated via the Result type.
 *
 * Run `npm run monsterrat:generate:contracts` to regenerate.
 */

import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import type {
  ActiveMessagesResponse,
  AddParticipantRequest,
  AdminCostsResponse,
  AdminMessageListResponse,
  AdminMessageResponse,
  AdminSessionCostsResponse,
  AiSearchRequest,
  AnalyzeResponse,
  AudioEpisodeByLessonResponse,
  AudioEpisodeDetailResponse,
  AudioProgressListResponse,
  AudioProgressResponse,
  AudioSeriesDetailResponse,
  AudioSeriesListResponse,
  CancelDeletionResponse,
  CheckLessonUpdatesRequest,
  CheckLessonUpdatesResponse,
  CompetenceMapResponse,
  ConfigResponse,
  CostRollupJobResponse,
  CoursesResponse,
  CreateAnnouncementMessageRequest,
  CreateBannerNoticeMessageRequest,
  CreateForceUpdateMessageRequest,
  CreateSessionRequest,
  CreateSoftUpdateMessageRequest,
  DeletionJobResponse,
  DeletionStatusResponse,
  DevCleanupTestUsersRequest,
  DevCreateSessionRequest,
  DevCreateTestUserRequest,
  DevRoleplayStartRequest,
  DevRoleplayStartResponse,
  DevRoleplayTurn,
  DevRoleplayTurnRequest,
  DevTestUser,
  DevTestUserCleanupResponse,
  DevTestUserListResponse,
  DevTestUserOtpRequest,
  DevTestUserOtpResponse,
  ExerciseGenerationRequest,
  ExerciseGenerationResponse,
  ExpressionItemDetailResponse,
  ExpressionItemListResponse,
  GenerateLessonRequest,
  GenerateLessonResponse,
  HealthResponse,
  LessonCompleteRequest,
  LessonCompleteResponse,
  LessonDetailResponse,
  LessonDraftResponse,
  LessonHistoryResponse,
  LessonIndexResponse,
  LessonListResponse,
  LessonPathResponse,
  LessonRecommendedResponse,
  LessonSearchRequest,
  LessonSearchResponse,
  LlmReconciliationJobResponse,
  MyReportsResponse,
  PromptsReloadResponse,
  QuickPracticeRequest,
  QuickPracticeResponse,
  ReconciliationBatchResponse,
  ReportAIContentRequest,
  ReportCreateResponse,
  RequestDeletionRequest,
  RequestDeletionResponse,
  RolePlayCollectionDetailResponse,
  RolePlayCollectionListResponse,
  RolePlaySlotDetailResponse,
  RolePlaySlotListResponse,
  RolePlayTemplateDetailResponse,
  RolePlayTemplateListResponse,
  SaveAudioProgressRequest,
  ScheduledLessonsResponse,
  SessionListResponse,
  SessionMessagesResponse,
  SessionSummary,
  SoundMapResponse,
  SpeechReconciliationJobResponse,
  SubmitFeedbackRequest,
  Subscription,
  SuccessEnvelope,
  SyncUserRequest,
  TargetCapabilitiesResponse,
  UpdateCoursePreferenceRequest,
  UpdatePreferencesRequest,
  UserProfile,
  VocabItemDetailResponse,
  VocabItemListResponse,
  VocabSetDetailResponse,
  VocabSetMarkRequest,
  VocabSetMarkResponse,
  VocabSetsResponse,
  VocabSummaryResponse,
} from './http-contracts';
import type {
  AddSessionParticipantDomainError,
  AddSessionParticipantResult,
  AiSearchLessonsDomainError,
  AiSearchLessonsResult,
  AnalyzeMessageDomainError,
  AnalyzeMessageResult,
  CancelDeletionDomainError,
  CancelDeletionResult,
  CheckHealthDomainError,
  CheckHealthResult,
  CheckLessonUpdatesDomainError,
  CheckLessonUpdatesResult,
  CompleteLessonAttemptDomainError,
  CompleteLessonAttemptResult,
  CreateSessionDomainError,
  CreateSessionResult,
  DeleteRolePlaySlotDomainError,
  DeleteRolePlaySlotResult,
  DismissMessageDomainError,
  DismissMessageResult,
  GenerateExercisesDomainError,
  GenerateExercisesResult,
  GenerateLessonDomainError,
  GenerateLessonResult,
  GenerateQuickPracticeDomainError,
  GenerateQuickPracticeResult,
  GetActiveMessagesDomainError,
  GetActiveMessagesResult,
  GetAudioEpisodeByLessonDomainError,
  GetAudioEpisodeByLessonResult,
  GetAudioEpisodeDomainError,
  GetAudioEpisodeResult,
  GetAudioSeriesDomainError,
  GetAudioSeriesResult,
  GetCompetenceMapDomainError,
  GetCompetenceMapResult,
  GetConfigDomainError,
  GetConfigResult,
  GetCoursesDomainError,
  GetCoursesResult,
  GetDeletionStatusDomainError,
  GetDeletionStatusResult,
  GetExpressionItemDomainError,
  GetExpressionItemResult,
  GetLessonDomainError,
  GetLessonDraftDomainError,
  GetLessonDraftResult,
  GetLessonHistoryDomainError,
  GetLessonHistoryResult,
  GetLessonIndexDomainError,
  GetLessonIndexResult,
  GetLessonPathDomainError,
  GetLessonPathResult,
  GetLessonResult,
  GetMyReportsDomainError,
  GetMyReportsResult,
  GetRecommendedLessonsDomainError,
  GetRecommendedLessonsResult,
  GetRolePlayCollectionDomainError,
  GetRolePlayCollectionResult,
  GetRolePlaySlotDomainError,
  GetRolePlaySlotResult,
  GetRolePlayTemplateDomainError,
  GetRolePlayTemplateResult,
  GetScheduledLessonsDomainError,
  GetScheduledLessonsResult,
  GetSessionMessagesDomainError,
  GetSessionMessagesResult,
  GetSoundMapDomainError,
  GetSoundMapResult,
  GetSubscriptionStatusDomainError,
  GetSubscriptionStatusResult,
  GetTargetCapabilitiesDomainError,
  GetTargetCapabilitiesResult,
  GetUserProfileDomainError,
  GetUserProfileResult,
  GetVocabItemDomainError,
  GetVocabItemResult,
  GetVocabSetDomainError,
  GetVocabSetResult,
  GetVocabSetsDomainError,
  GetVocabSetsResult,
  GetVocabSummaryDomainError,
  GetVocabSummaryResult,
  ListAudioProgressDomainError,
  ListAudioProgressResult,
  ListAudioSeriesDomainError,
  ListAudioSeriesResult,
  ListExpressionItemsDomainError,
  ListExpressionItemsResult,
  ListLessonsDomainError,
  ListLessonsResult,
  ListRolePlayCollectionsDomainError,
  ListRolePlayCollectionsResult,
  ListRolePlaySlotsDomainError,
  ListRolePlaySlotsResult,
  ListRolePlayTemplatesDomainError,
  ListRolePlayTemplatesResult,
  ListSessionsDomainError,
  ListSessionsResult,
  ListVocabItemsDomainError,
  ListVocabItemsResult,
  MarkVocabSetItemDomainError,
  MarkVocabSetItemResult,
  RefreshSubscriptionDomainError,
  RefreshSubscriptionResult,
  ReportAIContentDomainError,
  ReportAIContentResult,
  RequestDeletionDomainError,
  RequestDeletionResult,
  RestartRolePlaySlotDomainError,
  RestartRolePlaySlotResult,
  SaveAudioProgressDomainError,
  SaveAudioProgressResult,
  SearchLessonsDomainError,
  SearchLessonsResult,
  SearchRolePlayTemplatesDomainError,
  SearchRolePlayTemplatesResult,
  StartRolePlayTemplateDomainError,
  StartRolePlayTemplateResult,
  SubmitLessonFeedbackDomainError,
  SubmitLessonFeedbackResult,
  SyncUserDomainError,
  SyncUserResult,
  UpdateCoursePreferenceDomainError,
  UpdateCoursePreferenceResult,
  UpdatePreferencesDomainError,
  UpdatePreferencesResult,
} from './endpoint-error-types';
import { wrapError } from './endpoint-errors';

export function checkHealth(client: AxiosInstance, config?: AxiosRequestConfig): Promise<CheckHealthResult> {
  return client.get<HealthResponse>('/health', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<CheckHealthDomainError>(err, 'checkHealth'));
}

export function getConfig(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetConfigResult> {
  return client.get<ConfigResponse>('/config', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetConfigDomainError>(err, 'getConfig'));
}

export function getUserProfile(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetUserProfileResult> {
  return client.get<UserProfile>('/user/me', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetUserProfileDomainError>(err, 'getUserProfile'));
}

export function syncUser(client: AxiosInstance, data: SyncUserRequest, config?: AxiosRequestConfig): Promise<SyncUserResult> {
  return client.post<UserProfile>('/user/sync', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<SyncUserDomainError>(err, 'syncUser'));
}

export function updatePreferences(client: AxiosInstance, data: UpdatePreferencesRequest, config?: AxiosRequestConfig): Promise<UpdatePreferencesResult> {
  return client.patch<UserProfile>('/user/preferences', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<UpdatePreferencesDomainError>(err, 'updatePreferences'));
}

export function updateCoursePreference(client: AxiosInstance, data: UpdateCoursePreferenceRequest, config?: AxiosRequestConfig): Promise<UpdateCoursePreferenceResult> {
  return client.patch<UserProfile>('/user/course-preferences', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<UpdateCoursePreferenceDomainError>(err, 'updateCoursePreference'));
}

export function listLessons(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListLessonsResult> {
  return client.get<LessonListResponse>('/lessons', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListLessonsDomainError>(err, 'listLessons'));
}

export function getRecommendedLessons(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetRecommendedLessonsResult> {
  return client.get<LessonRecommendedResponse>('/lessons/recommended', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetRecommendedLessonsDomainError>(err, 'getRecommendedLessons'));
}

export function getLessonIndex(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetLessonIndexResult> {
  return client.get<LessonIndexResponse>('/lessons/index', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetLessonIndexDomainError>(err, 'getLessonIndex'));
}

export function getLessonPath(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetLessonPathResult> {
  return client.get<LessonPathResponse>('/lessons/path', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetLessonPathDomainError>(err, 'getLessonPath'));
}

export function getScheduledLessons(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetScheduledLessonsResult> {
  return client.get<ScheduledLessonsResponse>('/lessons/scheduled', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetScheduledLessonsDomainError>(err, 'getScheduledLessons'));
}

export function checkLessonUpdates(client: AxiosInstance, data: CheckLessonUpdatesRequest, config?: AxiosRequestConfig): Promise<CheckLessonUpdatesResult> {
  return client.post<CheckLessonUpdatesResponse>('/lessons/check-updates', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<CheckLessonUpdatesDomainError>(err, 'checkLessonUpdates'));
}

export function getLesson(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetLessonResult> {
  return client.get<LessonDetailResponse>(`/lessons/${slug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetLessonDomainError>(err, 'getLesson'));
}

export function getLessonHistory(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetLessonHistoryResult> {
  return client.get<LessonHistoryResponse>(`/lessons/${slug}/history`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetLessonHistoryDomainError>(err, 'getLessonHistory'));
}

export function getLessonDraft(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetLessonDraftResult> {
  return client.get<LessonDraftResponse>(`/lessons/draft/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetLessonDraftDomainError>(err, 'getLessonDraft'));
}

export function searchLessons(client: AxiosInstance, data: LessonSearchRequest, config?: AxiosRequestConfig): Promise<SearchLessonsResult> {
  return client.post<LessonSearchResponse>('/lessons/search', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<SearchLessonsDomainError>(err, 'searchLessons'));
}

export function aiSearchLessons(client: AxiosInstance, data: AiSearchRequest, config?: AxiosRequestConfig): Promise<AiSearchLessonsResult> {
  return client.post<LessonSearchResponse>('/lessons/ai-search', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<AiSearchLessonsDomainError>(err, 'aiSearchLessons'));
}

export function generateLesson(client: AxiosInstance, data: GenerateLessonRequest, config?: AxiosRequestConfig): Promise<GenerateLessonResult> {
  return client.post<GenerateLessonResponse>('/lessons/generate', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GenerateLessonDomainError>(err, 'generateLesson'));
}

export function generateExercises(client: AxiosInstance, slug: string, data: ExerciseGenerationRequest, config?: AxiosRequestConfig): Promise<GenerateExercisesResult> {
  return client.post<ExerciseGenerationResponse>(`/lessons/${slug}/generate-exercises`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GenerateExercisesDomainError>(err, 'generateExercises'));
}

export function completeLessonAttempt(client: AxiosInstance, slug: string, data: LessonCompleteRequest, config?: AxiosRequestConfig): Promise<CompleteLessonAttemptResult> {
  return client.post<LessonCompleteResponse>(`/lessons/${slug}/complete`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<CompleteLessonAttemptDomainError>(err, 'completeLessonAttempt'));
}

export function generateQuickPractice(client: AxiosInstance, data: QuickPracticeRequest, config?: AxiosRequestConfig): Promise<GenerateQuickPracticeResult> {
  return client.post<QuickPracticeResponse>('/lessons/quick-practice', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GenerateQuickPracticeDomainError>(err, 'generateQuickPractice'));
}

export function submitLessonFeedback(client: AxiosInstance, data: SubmitFeedbackRequest, config?: AxiosRequestConfig): Promise<SubmitLessonFeedbackResult> {
  return client.post<SuccessEnvelope>('/lessons/feedback', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<SubmitLessonFeedbackDomainError>(err, 'submitLessonFeedback'));
}

export function createSession(client: AxiosInstance, data: CreateSessionRequest, config?: AxiosRequestConfig): Promise<CreateSessionResult> {
  return client.post<SessionSummary>('/conversation/sessions', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<CreateSessionDomainError>(err, 'createSession'));
}

export function listSessions(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListSessionsResult> {
  return client.get<SessionListResponse>('/conversation/sessions', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListSessionsDomainError>(err, 'listSessions'));
}

export function addSessionParticipant(client: AxiosInstance, id: string, data: AddParticipantRequest, config?: AxiosRequestConfig): Promise<AddSessionParticipantResult> {
  return client.post<SuccessEnvelope>(`/conversation/sessions/${id}/participants`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<AddSessionParticipantDomainError>(err, 'addSessionParticipant'));
}

export function getSessionMessages(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetSessionMessagesResult> {
  return client.get<SessionMessagesResponse>(`/conversation/sessions/${id}/messages`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetSessionMessagesDomainError>(err, 'getSessionMessages'));
}

export function analyzeMessage(client: AxiosInstance, id: string, messageId: string, config?: AxiosRequestConfig): Promise<AnalyzeMessageResult> {
  return client.post<AnalyzeResponse>(`/conversation/sessions/${id}/messages/${messageId}/analyze`, undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<AnalyzeMessageDomainError>(err, 'analyzeMessage'));
}

export function listRolePlaySlots(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListRolePlaySlotsResult> {
  return client.get<RolePlaySlotListResponse>('/roleplay/slots', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListRolePlaySlotsDomainError>(err, 'listRolePlaySlots'));
}

export function getRolePlaySlot(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetRolePlaySlotResult> {
  return client.get<RolePlaySlotDetailResponse>(`/roleplay/slots/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetRolePlaySlotDomainError>(err, 'getRolePlaySlot'));
}

export function restartRolePlaySlot(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<RestartRolePlaySlotResult> {
  return client.post<RolePlaySlotDetailResponse>(`/roleplay/slots/${id}/restart`, undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<RestartRolePlaySlotDomainError>(err, 'restartRolePlaySlot'));
}

export function deleteRolePlaySlot(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<DeleteRolePlaySlotResult> {
  return client.delete<SuccessEnvelope>(`/roleplay/slots/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<DeleteRolePlaySlotDomainError>(err, 'deleteRolePlaySlot'));
}

export function listRolePlayTemplates(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListRolePlayTemplatesResult> {
  return client.get<RolePlayTemplateListResponse>('/roleplay/templates', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListRolePlayTemplatesDomainError>(err, 'listRolePlayTemplates'));
}

export function getRolePlayTemplate(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetRolePlayTemplateResult> {
  return client.get<RolePlayTemplateDetailResponse>(`/roleplay/templates/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetRolePlayTemplateDomainError>(err, 'getRolePlayTemplate'));
}

export function startRolePlayTemplate(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<StartRolePlayTemplateResult> {
  return client.post<RolePlaySlotDetailResponse>(`/roleplay/templates/${id}/start`, undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<StartRolePlayTemplateDomainError>(err, 'startRolePlayTemplate'));
}

export function listRolePlayCollections(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListRolePlayCollectionsResult> {
  return client.get<RolePlayCollectionListResponse>('/roleplay/collections', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListRolePlayCollectionsDomainError>(err, 'listRolePlayCollections'));
}

export function getRolePlayCollection(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetRolePlayCollectionResult> {
  return client.get<RolePlayCollectionDetailResponse>(`/roleplay/collections/${slug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetRolePlayCollectionDomainError>(err, 'getRolePlayCollection'));
}

export function searchRolePlayTemplates(client: AxiosInstance, config?: AxiosRequestConfig): Promise<SearchRolePlayTemplatesResult> {
  return client.get<RolePlayTemplateListResponse>('/roleplay/templates/search', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<SearchRolePlayTemplatesDomainError>(err, 'searchRolePlayTemplates'));
}

export function listVocabItems(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListVocabItemsResult> {
  return client.get<VocabItemListResponse>('/vocab/items', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListVocabItemsDomainError>(err, 'listVocabItems'));
}

export function getVocabItem(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetVocabItemResult> {
  return client.get<VocabItemDetailResponse>(`/vocab/items/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetVocabItemDomainError>(err, 'getVocabItem'));
}

export function listExpressionItems(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListExpressionItemsResult> {
  return client.get<ExpressionItemListResponse>('/vocab/expressions', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListExpressionItemsDomainError>(err, 'listExpressionItems'));
}

export function getExpressionItem(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<GetExpressionItemResult> {
  return client.get<ExpressionItemDetailResponse>(`/vocab/expressions/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetExpressionItemDomainError>(err, 'getExpressionItem'));
}

export function getVocabSummary(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetVocabSummaryResult> {
  return client.get<VocabSummaryResponse>('/vocab/summary', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetVocabSummaryDomainError>(err, 'getVocabSummary'));
}

export function getVocabSets(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetVocabSetsResult> {
  return client.get<VocabSetsResponse>('/vocab/sets', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetVocabSetsDomainError>(err, 'getVocabSets'));
}

export function getVocabSet(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetVocabSetResult> {
  return client.get<VocabSetDetailResponse>(`/vocab/sets/${slug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetVocabSetDomainError>(err, 'getVocabSet'));
}

export function markVocabSetItem(client: AxiosInstance, slug: string, data: VocabSetMarkRequest, config?: AxiosRequestConfig): Promise<MarkVocabSetItemResult> {
  return client.post<VocabSetMarkResponse>(`/vocab/sets/${slug}/mark`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<MarkVocabSetItemDomainError>(err, 'markVocabSetItem'));
}

export function getDeletionStatus(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetDeletionStatusResult> {
  return client.get<DeletionStatusResponse>('/account/deletion-status', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetDeletionStatusDomainError>(err, 'getDeletionStatus'));
}

export function requestDeletion(client: AxiosInstance, data: RequestDeletionRequest, config?: AxiosRequestConfig): Promise<RequestDeletionResult> {
  return client.post<RequestDeletionResponse>('/account/request-deletion', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<RequestDeletionDomainError>(err, 'requestDeletion'));
}

export function cancelDeletion(client: AxiosInstance, config?: AxiosRequestConfig): Promise<CancelDeletionResult> {
  return client.post<CancelDeletionResponse>('/account/cancel-deletion', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<CancelDeletionDomainError>(err, 'cancelDeletion'));
}

export function getSubscriptionStatus(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetSubscriptionStatusResult> {
  return client.get<Subscription>('/subscription/status', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetSubscriptionStatusDomainError>(err, 'getSubscriptionStatus'));
}

export function refreshSubscription(client: AxiosInstance, config?: AxiosRequestConfig): Promise<RefreshSubscriptionResult> {
  return client.post<Subscription>('/subscription/refresh', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<RefreshSubscriptionDomainError>(err, 'refreshSubscription'));
}

export function getSoundMap(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetSoundMapResult> {
  return client.get<SoundMapResponse>('/speech/sound-map', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetSoundMapDomainError>(err, 'getSoundMap'));
}

export function getCompetenceMap(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetCompetenceMapResult> {
  return client.get<CompetenceMapResponse>('/grammar/competence-map', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetCompetenceMapDomainError>(err, 'getCompetenceMap'));
}

export function reportAIContent(client: AxiosInstance, data: ReportAIContentRequest, config?: AxiosRequestConfig): Promise<ReportAIContentResult> {
  return client.post<ReportCreateResponse>('/reports/ai-content', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ReportAIContentDomainError>(err, 'reportAIContent'));
}

export function getMyReports(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetMyReportsResult> {
  return client.get<MyReportsResponse>('/reports/ai-content/my-reports', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetMyReportsDomainError>(err, 'getMyReports'));
}

export function getActiveMessages(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetActiveMessagesResult> {
  return client.get<ActiveMessagesResponse>('/messages/active', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetActiveMessagesDomainError>(err, 'getActiveMessages'));
}

export function dismissMessage(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<DismissMessageResult> {
  return client.post<SuccessEnvelope>(`/messages/${id}/dismiss`, undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<DismissMessageDomainError>(err, 'dismissMessage'));
}

export function getCourses(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetCoursesResult> {
  return client.get<CoursesResponse>('/courses', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetCoursesDomainError>(err, 'getCourses'));
}

export function getTargetCapabilities(client: AxiosInstance, config?: AxiosRequestConfig): Promise<GetTargetCapabilitiesResult> {
  return client.get<TargetCapabilitiesResponse>('/courses/capabilities', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetTargetCapabilitiesDomainError>(err, 'getTargetCapabilities'));
}

export function postWebhooksRevenuecat(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: unknown } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/webhooks/revenuecat', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postWebhooksRevenuecat'));
}

export function postJobsProcessDeletions(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: DeletionJobResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/jobs/process-deletions', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postJobsProcessDeletions'));
}

export function postJobsReconcileSubscriptions(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: ReconciliationBatchResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/jobs/reconcile-subscriptions', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postJobsReconcileSubscriptions'));
}

export function postJobsRollupCosts(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: CostRollupJobResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/jobs/rollup-costs', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postJobsRollupCosts'));
}

export function postJobsReconcileSpeech(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: SpeechReconciliationJobResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/jobs/reconcile-speech', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postJobsReconcileSpeech'));
}

export function postJobsReconcileLlm(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: LlmReconciliationJobResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/jobs/reconcile-llm', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postJobsReconcileLlm'));
}

export function getJobsHealth(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: unknown } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get('/jobs/health', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getJobsHealth'));
}

export function postAdminPromptsReload(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: PromptsReloadResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/admin/prompts/reload', undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postAdminPromptsReload'));
}

export function getAdminCosts(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminCostsResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get('/admin/costs', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getAdminCosts'));
}

export function getAdminCostsSessionSessionId(client: AxiosInstance, sessionId: string, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminSessionCostsResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get(`/admin/costs/session/${sessionId}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getAdminCostsSessionSessionId'));
}

export function getAdminMessages(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageListResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get('/admin/messages', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getAdminMessages'));
}

export function postAdminMessagesForceUpdate(client: AxiosInstance, data: CreateForceUpdateMessageRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/admin/messages/force-update', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postAdminMessagesForceUpdate'));
}

export function postAdminMessagesSoftUpdate(client: AxiosInstance, data: CreateSoftUpdateMessageRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/admin/messages/soft-update', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postAdminMessagesSoftUpdate'));
}

export function postAdminMessagesAnnouncement(client: AxiosInstance, data: CreateAnnouncementMessageRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/admin/messages/announcement', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postAdminMessagesAnnouncement'));
}

export function postAdminMessagesBannerNotice(client: AxiosInstance, data: CreateBannerNoticeMessageRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/admin/messages/banner-notice', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postAdminMessagesBannerNotice'));
}

export function getAdminMessagesId(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get(`/admin/messages/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getAdminMessagesId'));
}

export function patchAdminMessagesIdDeactivate(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<{ ok: true; data: AdminMessageResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.patch(`/admin/messages/${id}/deactivate`, undefined, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'patchAdminMessagesIdDeactivate'));
}

export function delAdminMessagesId(client: AxiosInstance, id: string, config?: AxiosRequestConfig): Promise<{ ok: true; data: SuccessEnvelope } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.delete(`/admin/messages/${id}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'delAdminMessagesId'));
}

export function getDevCourses(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: CoursesResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get('/dev/courses', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getDevCourses'));
}

export function postDevSessions(client: AxiosInstance, data: DevCreateSessionRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: SessionSummary } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/dev/sessions', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevSessions'));
}

export function postDevRoleplaySessions(client: AxiosInstance, data: DevRoleplayStartRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevRoleplayStartResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/dev/roleplay/sessions', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevRoleplaySessions'));
}

export function postDevRoleplaySessionsSessionIdTurn(client: AxiosInstance, sessionId: string, data: DevRoleplayTurnRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevRoleplayTurn } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post(`/dev/roleplay/sessions/${sessionId}/turn`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevRoleplaySessionsSessionIdTurn'));
}

export function postDevTestUsers(client: AxiosInstance, data: DevCreateTestUserRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevTestUser } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/dev/test-users', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevTestUsers'));
}

export function getDevTestUsers(client: AxiosInstance, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevTestUserListResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.get('/dev/test-users', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'getDevTestUsers'));
}

export function postDevTestUsersRecoveryOtp(client: AxiosInstance, data: DevTestUserOtpRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevTestUserOtpResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/dev/test-users/recovery-otp', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevTestUsersRecoveryOtp'));
}

export function postDevTestUsersCleanup(client: AxiosInstance, data: DevCleanupTestUsersRequest, config?: AxiosRequestConfig): Promise<{ ok: true; data: DevTestUserCleanupResponse } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.post('/dev/test-users/cleanup', data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'postDevTestUsersCleanup'));
}

export function delDevTestUsersUserId(client: AxiosInstance, userId: string, config?: AxiosRequestConfig): Promise<{ ok: true; data: SuccessEnvelope } | { ok: false; kind: 'domain' | 'transport'; error: unknown }> {
  return client.delete(`/dev/test-users/${userId}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError(err, 'delDevTestUsersUserId'));
}

export function listAudioSeries(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListAudioSeriesResult> {
  return client.get<AudioSeriesListResponse>('/audio/series', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListAudioSeriesDomainError>(err, 'listAudioSeries'));
}

export function getAudioSeries(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetAudioSeriesResult> {
  return client.get<AudioSeriesDetailResponse>(`/audio/series/${slug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetAudioSeriesDomainError>(err, 'getAudioSeries'));
}

export function listAudioProgress(client: AxiosInstance, config?: AxiosRequestConfig): Promise<ListAudioProgressResult> {
  return client.get<AudioProgressListResponse>('/audio/progress', config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<ListAudioProgressDomainError>(err, 'listAudioProgress'));
}

export function getAudioEpisodeByLesson(client: AxiosInstance, lessonSlug: string, config?: AxiosRequestConfig): Promise<GetAudioEpisodeByLessonResult> {
  return client.get<AudioEpisodeByLessonResponse>(`/audio/episodes/by-lesson/${lessonSlug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetAudioEpisodeByLessonDomainError>(err, 'getAudioEpisodeByLesson'));
}

export function getAudioEpisode(client: AxiosInstance, slug: string, config?: AxiosRequestConfig): Promise<GetAudioEpisodeResult> {
  return client.get<AudioEpisodeDetailResponse>(`/audio/episodes/${slug}`, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<GetAudioEpisodeDomainError>(err, 'getAudioEpisode'));
}

export function saveAudioProgress(client: AxiosInstance, slug: string, data: SaveAudioProgressRequest, config?: AxiosRequestConfig): Promise<SaveAudioProgressResult> {
  return client.post<AudioProgressResponse>(`/audio/episodes/${slug}/progress`, data, config)
    .then(res => ({ ok: true as const, data: res.data }))
    .catch(err => wrapError<SaveAudioProgressDomainError>(err, 'saveAudioProgress'));
}

// ── Client Binding ──────────────────────────────────────────────

/**
 * Bind all generated API functions to a configured AxiosInstance.
 * Returns an object with the same functions, but without the `client` parameter.
 */
export function bindClient(client: AxiosInstance) {
  return {
    checkHealth: (config?: AxiosRequestConfig) => checkHealth(client, config),
    getConfig: (config?: AxiosRequestConfig) => getConfig(client, config),
    getUserProfile: (config?: AxiosRequestConfig) => getUserProfile(client, config),
    syncUser: (data: SyncUserRequest, config?: AxiosRequestConfig) => syncUser(client, data, config),
    updatePreferences: (data: UpdatePreferencesRequest, config?: AxiosRequestConfig) => updatePreferences(client, data, config),
    updateCoursePreference: (data: UpdateCoursePreferenceRequest, config?: AxiosRequestConfig) => updateCoursePreference(client, data, config),
    listLessons: (config?: AxiosRequestConfig) => listLessons(client, config),
    getRecommendedLessons: (config?: AxiosRequestConfig) => getRecommendedLessons(client, config),
    getLessonIndex: (config?: AxiosRequestConfig) => getLessonIndex(client, config),
    getLessonPath: (config?: AxiosRequestConfig) => getLessonPath(client, config),
    getScheduledLessons: (config?: AxiosRequestConfig) => getScheduledLessons(client, config),
    checkLessonUpdates: (data: CheckLessonUpdatesRequest, config?: AxiosRequestConfig) => checkLessonUpdates(client, data, config),
    getLesson: (slug: string, config?: AxiosRequestConfig) => getLesson(client, slug, config),
    getLessonHistory: (slug: string, config?: AxiosRequestConfig) => getLessonHistory(client, slug, config),
    getLessonDraft: (id: string, config?: AxiosRequestConfig) => getLessonDraft(client, id, config),
    searchLessons: (data: LessonSearchRequest, config?: AxiosRequestConfig) => searchLessons(client, data, config),
    aiSearchLessons: (data: AiSearchRequest, config?: AxiosRequestConfig) => aiSearchLessons(client, data, config),
    generateLesson: (data: GenerateLessonRequest, config?: AxiosRequestConfig) => generateLesson(client, data, config),
    generateExercises: (slug: string, data: ExerciseGenerationRequest, config?: AxiosRequestConfig) => generateExercises(client, slug, data, config),
    completeLessonAttempt: (slug: string, data: LessonCompleteRequest, config?: AxiosRequestConfig) => completeLessonAttempt(client, slug, data, config),
    generateQuickPractice: (data: QuickPracticeRequest, config?: AxiosRequestConfig) => generateQuickPractice(client, data, config),
    submitLessonFeedback: (data: SubmitFeedbackRequest, config?: AxiosRequestConfig) => submitLessonFeedback(client, data, config),
    createSession: (data: CreateSessionRequest, config?: AxiosRequestConfig) => createSession(client, data, config),
    listSessions: (config?: AxiosRequestConfig) => listSessions(client, config),
    addSessionParticipant: (id: string, data: AddParticipantRequest, config?: AxiosRequestConfig) => addSessionParticipant(client, id, data, config),
    getSessionMessages: (id: string, config?: AxiosRequestConfig) => getSessionMessages(client, id, config),
    analyzeMessage: (id: string, messageId: string, config?: AxiosRequestConfig) => analyzeMessage(client, id, messageId, config),
    listRolePlaySlots: (config?: AxiosRequestConfig) => listRolePlaySlots(client, config),
    getRolePlaySlot: (id: string, config?: AxiosRequestConfig) => getRolePlaySlot(client, id, config),
    restartRolePlaySlot: (id: string, config?: AxiosRequestConfig) => restartRolePlaySlot(client, id, config),
    deleteRolePlaySlot: (id: string, config?: AxiosRequestConfig) => deleteRolePlaySlot(client, id, config),
    listRolePlayTemplates: (config?: AxiosRequestConfig) => listRolePlayTemplates(client, config),
    getRolePlayTemplate: (id: string, config?: AxiosRequestConfig) => getRolePlayTemplate(client, id, config),
    startRolePlayTemplate: (id: string, config?: AxiosRequestConfig) => startRolePlayTemplate(client, id, config),
    listRolePlayCollections: (config?: AxiosRequestConfig) => listRolePlayCollections(client, config),
    getRolePlayCollection: (slug: string, config?: AxiosRequestConfig) => getRolePlayCollection(client, slug, config),
    searchRolePlayTemplates: (config?: AxiosRequestConfig) => searchRolePlayTemplates(client, config),
    listVocabItems: (config?: AxiosRequestConfig) => listVocabItems(client, config),
    getVocabItem: (id: string, config?: AxiosRequestConfig) => getVocabItem(client, id, config),
    listExpressionItems: (config?: AxiosRequestConfig) => listExpressionItems(client, config),
    getExpressionItem: (id: string, config?: AxiosRequestConfig) => getExpressionItem(client, id, config),
    getVocabSummary: (config?: AxiosRequestConfig) => getVocabSummary(client, config),
    getVocabSets: (config?: AxiosRequestConfig) => getVocabSets(client, config),
    getVocabSet: (slug: string, config?: AxiosRequestConfig) => getVocabSet(client, slug, config),
    markVocabSetItem: (slug: string, data: VocabSetMarkRequest, config?: AxiosRequestConfig) => markVocabSetItem(client, slug, data, config),
    getDeletionStatus: (config?: AxiosRequestConfig) => getDeletionStatus(client, config),
    requestDeletion: (data: RequestDeletionRequest, config?: AxiosRequestConfig) => requestDeletion(client, data, config),
    cancelDeletion: (config?: AxiosRequestConfig) => cancelDeletion(client, config),
    getSubscriptionStatus: (config?: AxiosRequestConfig) => getSubscriptionStatus(client, config),
    refreshSubscription: (config?: AxiosRequestConfig) => refreshSubscription(client, config),
    getSoundMap: (config?: AxiosRequestConfig) => getSoundMap(client, config),
    getCompetenceMap: (config?: AxiosRequestConfig) => getCompetenceMap(client, config),
    reportAIContent: (data: ReportAIContentRequest, config?: AxiosRequestConfig) => reportAIContent(client, data, config),
    getMyReports: (config?: AxiosRequestConfig) => getMyReports(client, config),
    getActiveMessages: (config?: AxiosRequestConfig) => getActiveMessages(client, config),
    dismissMessage: (id: string, config?: AxiosRequestConfig) => dismissMessage(client, id, config),
    getCourses: (config?: AxiosRequestConfig) => getCourses(client, config),
    getTargetCapabilities: (config?: AxiosRequestConfig) => getTargetCapabilities(client, config),
    postWebhooksRevenuecat: (config?: AxiosRequestConfig) => postWebhooksRevenuecat(client, config),
    postJobsProcessDeletions: (config?: AxiosRequestConfig) => postJobsProcessDeletions(client, config),
    postJobsReconcileSubscriptions: (config?: AxiosRequestConfig) => postJobsReconcileSubscriptions(client, config),
    postJobsRollupCosts: (config?: AxiosRequestConfig) => postJobsRollupCosts(client, config),
    postJobsReconcileSpeech: (config?: AxiosRequestConfig) => postJobsReconcileSpeech(client, config),
    postJobsReconcileLlm: (config?: AxiosRequestConfig) => postJobsReconcileLlm(client, config),
    getJobsHealth: (config?: AxiosRequestConfig) => getJobsHealth(client, config),
    postAdminPromptsReload: (config?: AxiosRequestConfig) => postAdminPromptsReload(client, config),
    getAdminCosts: (config?: AxiosRequestConfig) => getAdminCosts(client, config),
    getAdminCostsSessionSessionId: (sessionId: string, config?: AxiosRequestConfig) => getAdminCostsSessionSessionId(client, sessionId, config),
    getAdminMessages: (config?: AxiosRequestConfig) => getAdminMessages(client, config),
    postAdminMessagesForceUpdate: (data: CreateForceUpdateMessageRequest, config?: AxiosRequestConfig) => postAdminMessagesForceUpdate(client, data, config),
    postAdminMessagesSoftUpdate: (data: CreateSoftUpdateMessageRequest, config?: AxiosRequestConfig) => postAdminMessagesSoftUpdate(client, data, config),
    postAdminMessagesAnnouncement: (data: CreateAnnouncementMessageRequest, config?: AxiosRequestConfig) => postAdminMessagesAnnouncement(client, data, config),
    postAdminMessagesBannerNotice: (data: CreateBannerNoticeMessageRequest, config?: AxiosRequestConfig) => postAdminMessagesBannerNotice(client, data, config),
    getAdminMessagesId: (id: string, config?: AxiosRequestConfig) => getAdminMessagesId(client, id, config),
    patchAdminMessagesIdDeactivate: (id: string, config?: AxiosRequestConfig) => patchAdminMessagesIdDeactivate(client, id, config),
    delAdminMessagesId: (id: string, config?: AxiosRequestConfig) => delAdminMessagesId(client, id, config),
    getDevCourses: (config?: AxiosRequestConfig) => getDevCourses(client, config),
    postDevSessions: (data: DevCreateSessionRequest, config?: AxiosRequestConfig) => postDevSessions(client, data, config),
    postDevRoleplaySessions: (data: DevRoleplayStartRequest, config?: AxiosRequestConfig) => postDevRoleplaySessions(client, data, config),
    postDevRoleplaySessionsSessionIdTurn: (sessionId: string, data: DevRoleplayTurnRequest, config?: AxiosRequestConfig) => postDevRoleplaySessionsSessionIdTurn(client, sessionId, data, config),
    postDevTestUsers: (data: DevCreateTestUserRequest, config?: AxiosRequestConfig) => postDevTestUsers(client, data, config),
    getDevTestUsers: (config?: AxiosRequestConfig) => getDevTestUsers(client, config),
    postDevTestUsersRecoveryOtp: (data: DevTestUserOtpRequest, config?: AxiosRequestConfig) => postDevTestUsersRecoveryOtp(client, data, config),
    postDevTestUsersCleanup: (data: DevCleanupTestUsersRequest, config?: AxiosRequestConfig) => postDevTestUsersCleanup(client, data, config),
    delDevTestUsersUserId: (userId: string, config?: AxiosRequestConfig) => delDevTestUsersUserId(client, userId, config),
    listAudioSeries: (config?: AxiosRequestConfig) => listAudioSeries(client, config),
    getAudioSeries: (slug: string, config?: AxiosRequestConfig) => getAudioSeries(client, slug, config),
    listAudioProgress: (config?: AxiosRequestConfig) => listAudioProgress(client, config),
    getAudioEpisodeByLesson: (lessonSlug: string, config?: AxiosRequestConfig) => getAudioEpisodeByLesson(client, lessonSlug, config),
    getAudioEpisode: (slug: string, config?: AxiosRequestConfig) => getAudioEpisode(client, slug, config),
    saveAudioProgress: (slug: string, data: SaveAudioProgressRequest, config?: AxiosRequestConfig) => saveAudioProgress(client, slug, data, config),
  };
}

/** All generated endpoint function names — for contract validation */
export const GeneratedEndpoints = {
  'GET /api/health': 'checkHealth',
  'GET /api/config': 'getConfig',
  'GET /api/user/me': 'getUserProfile',
  'POST /api/user/sync': 'syncUser',
  'PATCH /api/user/preferences': 'updatePreferences',
  'PATCH /api/user/course-preferences': 'updateCoursePreference',
  'GET /api/lessons': 'listLessons',
  'GET /api/lessons/recommended': 'getRecommendedLessons',
  'GET /api/lessons/index': 'getLessonIndex',
  'GET /api/lessons/path': 'getLessonPath',
  'GET /api/lessons/scheduled': 'getScheduledLessons',
  'POST /api/lessons/check-updates': 'checkLessonUpdates',
  'GET /api/lessons/:slug': 'getLesson',
  'GET /api/lessons/:slug/history': 'getLessonHistory',
  'GET /api/lessons/draft/:id': 'getLessonDraft',
  'POST /api/lessons/search': 'searchLessons',
  'POST /api/lessons/ai-search': 'aiSearchLessons',
  'POST /api/lessons/generate': 'generateLesson',
  'POST /api/lessons/:slug/generate-exercises': 'generateExercises',
  'POST /api/lessons/:slug/complete': 'completeLessonAttempt',
  'POST /api/lessons/quick-practice': 'generateQuickPractice',
  'POST /api/lessons/feedback': 'submitLessonFeedback',
  'POST /api/conversation/sessions': 'createSession',
  'GET /api/conversation/sessions': 'listSessions',
  'POST /api/conversation/sessions/:id/participants': 'addSessionParticipant',
  'GET /api/conversation/sessions/:id/messages': 'getSessionMessages',
  'POST /api/conversation/sessions/:id/messages/:messageId/analyze': 'analyzeMessage',
  'GET /api/roleplay/slots': 'listRolePlaySlots',
  'GET /api/roleplay/slots/:id': 'getRolePlaySlot',
  'POST /api/roleplay/slots/:id/restart': 'restartRolePlaySlot',
  'DELETE /api/roleplay/slots/:id': 'deleteRolePlaySlot',
  'GET /api/roleplay/templates': 'listRolePlayTemplates',
  'GET /api/roleplay/templates/:id': 'getRolePlayTemplate',
  'POST /api/roleplay/templates/:id/start': 'startRolePlayTemplate',
  'GET /api/roleplay/collections': 'listRolePlayCollections',
  'GET /api/roleplay/collections/:slug': 'getRolePlayCollection',
  'GET /api/roleplay/templates/search': 'searchRolePlayTemplates',
  'GET /api/vocab/items': 'listVocabItems',
  'GET /api/vocab/items/:id': 'getVocabItem',
  'GET /api/vocab/expressions': 'listExpressionItems',
  'GET /api/vocab/expressions/:id': 'getExpressionItem',
  'GET /api/vocab/summary': 'getVocabSummary',
  'GET /api/vocab/sets': 'getVocabSets',
  'GET /api/vocab/sets/:slug': 'getVocabSet',
  'POST /api/vocab/sets/:slug/mark': 'markVocabSetItem',
  'GET /api/account/deletion-status': 'getDeletionStatus',
  'POST /api/account/request-deletion': 'requestDeletion',
  'POST /api/account/cancel-deletion': 'cancelDeletion',
  'GET /api/subscription/status': 'getSubscriptionStatus',
  'POST /api/subscription/refresh': 'refreshSubscription',
  'GET /api/speech/sound-map': 'getSoundMap',
  'GET /api/grammar/competence-map': 'getCompetenceMap',
  'POST /api/reports/ai-content': 'reportAIContent',
  'GET /api/reports/ai-content/my-reports': 'getMyReports',
  'GET /api/messages/active': 'getActiveMessages',
  'POST /api/messages/:id/dismiss': 'dismissMessage',
  'GET /api/courses': 'getCourses',
  'GET /api/courses/capabilities': 'getTargetCapabilities',
  'POST /api/webhooks/revenuecat': 'postWebhooksRevenuecat',
  'POST /api/jobs/process-deletions': 'postJobsProcessDeletions',
  'POST /api/jobs/reconcile-subscriptions': 'postJobsReconcileSubscriptions',
  'POST /api/jobs/rollup-costs': 'postJobsRollupCosts',
  'POST /api/jobs/reconcile-speech': 'postJobsReconcileSpeech',
  'POST /api/jobs/reconcile-llm': 'postJobsReconcileLlm',
  'GET /api/jobs/health': 'getJobsHealth',
  'POST /api/admin/prompts/reload': 'postAdminPromptsReload',
  'GET /api/admin/costs': 'getAdminCosts',
  'GET /api/admin/costs/session/:sessionId': 'getAdminCostsSessionSessionId',
  'GET /api/admin/messages': 'getAdminMessages',
  'POST /api/admin/messages/force-update': 'postAdminMessagesForceUpdate',
  'POST /api/admin/messages/soft-update': 'postAdminMessagesSoftUpdate',
  'POST /api/admin/messages/announcement': 'postAdminMessagesAnnouncement',
  'POST /api/admin/messages/banner-notice': 'postAdminMessagesBannerNotice',
  'GET /api/admin/messages/:id': 'getAdminMessagesId',
  'PATCH /api/admin/messages/:id/deactivate': 'patchAdminMessagesIdDeactivate',
  'DELETE /api/admin/messages/:id': 'delAdminMessagesId',
  'GET /api/dev/courses': 'getDevCourses',
  'POST /api/dev/sessions': 'postDevSessions',
  'POST /api/dev/roleplay/sessions': 'postDevRoleplaySessions',
  'POST /api/dev/roleplay/sessions/:sessionId/turn': 'postDevRoleplaySessionsSessionIdTurn',
  'POST /api/dev/test-users': 'postDevTestUsers',
  'GET /api/dev/test-users': 'getDevTestUsers',
  'POST /api/dev/test-users/recovery-otp': 'postDevTestUsersRecoveryOtp',
  'POST /api/dev/test-users/cleanup': 'postDevTestUsersCleanup',
  'DELETE /api/dev/test-users/:userId': 'delDevTestUsersUserId',
  'GET /api/audio/series': 'listAudioSeries',
  'GET /api/audio/series/:slug': 'getAudioSeries',
  'GET /api/audio/progress': 'listAudioProgress',
  'GET /api/audio/episodes/by-lesson/:lessonSlug': 'getAudioEpisodeByLesson',
  'GET /api/audio/episodes/:slug': 'getAudioEpisode',
  'POST /api/audio/episodes/:slug/progress': 'saveAudioProgress',
} as const;

